import React, { useState, useEffect } from 'react';
import {
  Container,
  Col,
  Row,
  Card,
  CardBody,
  Label,
  CustomInput,
  FormGroup,
  Button,
  Spinner,
} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import useAttachement from '../../helpers/hooks/useAttachments';
import toastr from 'toastr';
import _ from 'lodash';
const CitiesDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [city, , cityLoading] = useGet(
    `/cities/${id}`,
    true
  );

  const [postCity, postedData, postingError, dataPosting] = usePatch(
    `/cities/${id}`
  );

  const handleFormSubmit = (event, errors, values) => {
    if (errors.length > 0) {
      return toastr.warning('Please fix errors in the form');
    }

    const obj = _.omit({
      ...values,
    });
    postCity(obj);
  };

  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('City has been updated successfully');
      history.push('/system/cities');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleFormSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit City</h4>
                <Card>
                  <CardBody>
                     {cityLoading ? (
                      <div className='text-center'>
                        <Spinner className='mr-2' color='primary' />
                      </div>
                    ) : (
                      <>
                        <FormGroup>
                          <Label htmlFor='name'>Name</Label>
                          <AvField
                            name='name'
                            placeholder='Name'
                            type='text'
                            errorMessage='Enter Name'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='name'
                            value={city?.name}
                          />
                        </FormGroup>
                       
                      </>
                     )} 
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting}
                  > 
                    {dataPosting 
                      ? 'Saving...'
                      : 'Update City'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};

export default CitiesDetails;

